import { FC } from 'react';

// Third-party
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

// Components
import { Iconify } from '@mgm/common/components';
import { BASE_COLORS } from '@mgm/common/utils';
import { TBaseTable } from '@mgm/common/components/table';
import { CustomToolbar } from '../../../../../components/table';

// Hooks
import { useAppDispatch } from '../../../../../hooks/useAppStore';
import { useSheetsPermissions } from '../../../hooks';

// Redux-toolkit
import { sheetsActions } from '../../../../../store/sheets/slice';
import { commonActions } from '../../../../../store/common/slice';

// Types
import { TTimeCardShift } from '../../../../../types';

const TimesheetsMemberTableHeader: FC<TBaseTable> = ({
  apiRef,
  exportFileName,
  printRef,
  handleScrollTable,
  isFullTable = false,
  setIsFullTable = () => {},
  handleExport,
}) => {
  const { t } = useTranslation('timesheets');
  const dispatch = useAppDispatch();
  const { permissions } = useSheetsPermissions();

  const openCreateShiftNav = () => {
    dispatch(commonActions.setIsOpenPagesNav(true));

    dispatch(sheetsActions.setSelectedShift({} as TTimeCardShift));
  };

  return (
    <CustomToolbar
      handleScrollTable={handleScrollTable}
      printRef={printRef}
      exportFileName={exportFileName}
      isDisplayCustomFilter={false}
      apiRef={apiRef}
      isFullTable={isFullTable}
      setFullTable={setIsFullTable}
      handleExport={handleExport}
      customAction={(
        permissions.isAllowManage
          ? (
            <Button
              variant="contained"
              size="small"
              id="add-shift"
              onClick={openCreateShiftNav}
              endIcon={(
                <Iconify
                  icon="ic:round-plus"
                  width={20}
                  sx={{
                    color: BASE_COLORS.white,
                  }}
                />
              )}
            >
              {t('addShift')}
            </Button>
          ) : <div />
        )}
    />
  );
};

export {
  TimesheetsMemberTableHeader,
};
